import { useMemo, type ReactNode } from 'react'
import type { MembershipsResponse } from '@/api/pending'
import { env } from '@/app/env'
import { AccessContext, type Access } from './useAccess'
import { allowedSections, capabilitiesFor, managerContexts, roleLabel } from './sections'

export function AccessProvider({
  me,
  condoId,
  children,
}: {
  me: MembershipsResponse
  condoId: number
  children: ReactNode
}) {
  const value = useMemo<Access | null>(() => {
    const membership = me.memberships.find((m) => m.condominium_id === condoId)
    if (!membership) return null
    const capabilities = capabilitiesFor(me, condoId)
    return {
      me,
      condoId,
      membership,
      capabilities,
      sections: allowedSections(capabilities, env.features),
      roleLabel: roleLabel(membership.scopes, me.is_root),
      contexts: managerContexts(me),
    }
  }, [me, condoId])
  if (!value) return null
  return <AccessContext.Provider value={value}>{children}</AccessContext.Provider>
}
